import { render, staticRenderFns } from "./staffSelector.vue?vue&type=template&id=3d8dbf63&scoped=true&"
import script from "./staffSelector.vue?vue&type=script&lang=js&"
export * from "./staffSelector.vue?vue&type=script&lang=js&"
import style0 from "./staffSelector.vue?vue&type=style&index=0&id=3d8dbf63&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d8dbf63",
  null
  
)

export default component.exports